export default __webpack_public_path__ + "static/media/affiliate-feature-bonus.02a36fdd.svg";